<template>
  <transition name="Auth-">

    <div class="Auth" v-if="authenticate">

      <div class="Auth-header t-antialiased">

        <div class="Auth-headerContainer">

          <icon class="Auth-headerLock"
            name="lock"
            width="14.839px"
            height="18px" />

          <h1 class="t-heading-caps c-white">Protected area</h1>

        </div>

      </div>

      <div class="Auth-content" v-show="initialized">

        <text-input class="Auth-password"
          ref="password"
          v-model="password"
          @submit="submit"
          @keyup.enter="submit"
          @keyup.esc="close"
          placeholder="Enter password"
          type="password"
          large
          focus />

        <p class="Auth-feedback t-text-sm c-grey-lt"
          v-show="message">
          <break />
          {{ message }}
        </p>

      </div>

      <div class="Auth-footer t-antialiased">

        <p class="Auth-message t-text-sm c-grey-lt">
          Not working? <a :href="`mailto:${global.site.email.value}`">Contact us</a> or visit the <router-link :to="{ name: 'home' }">home page</router-link>.
        </p>

      </div>

      <div class="Auth-backdrop" @click="close"></div>

    </div>

  </transition>
</template>

<script>
import auth from 'app/src/router/auth'

export default {
  name: 'Auth',

  data () {
    return {
      initialized: false,
      password: '',
      message: ''
    }
  },

  computed: {
    authenticate () { return this.$store.state.authenticate }
  },

  created () {
    if (this.authenticate) this.initialized = true
  },

  watch: {
    authenticate () {
      if (!this.authenticate) {
        this.initialized = false
        this.password = ''
        this.message = ''
        return
      }

      this.$nextTick(() => {
        this.initialized = true
      })
    }
  },

  methods: {
    /**
     * Handle keydown event
     */
    submit () {
      this.verifyPassword()
    },

    /**
     * Verify password
     */
    verifyPassword () {
      if (auth.verifyPassword(this.password, this.authenticate.passHash)) {
        // Grant user access to route
        auth.grantUserAccessToRoute(this.authenticate.routeHash)

        // Send to requested route
        this.$router.push({ path: this.authenticate.toRoute })
        return
      }

      this.showWrongPasswordMessage()
    },

    showWrongPasswordMessage () {
      this.message = 'Password is incorrect.'
    },

    /**
     * Close
     */
    close () {
      // When we're in the login view, prevent close
      if (this.$route.name === 'login') return
      this.$store.dispatch('authenticate', false)
    }
  }
}
</script>

<style>
@import 'properties';

.Auth {
  position: absolute;
  z-index: 900;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: var(--unit);
}

.Auth--enter-active {
  transition: opacity 0.25s ease;
}

.Auth--leave-active {
  transition: opacity 0.25s ease;
}

.Auth--enter,
.Auth--leave-active {
  opacity: 0;
}

.Auth-header {
  position: relative;
  z-index: 100;
  text-align: center;
}

.Auth-headerContainer {
  display: flex;
  /*align-items: center;*/
}

.Auth-headerLock {
  position: relative;
  top: 1px;
  margin-right: var(--unit-075);
}

.Auth-headerLock svg {
  fill: var(--c-grey-lt) !important;
}

.Auth-content {
  position: relative;
  z-index: 100;
  top: -4px;
  margin-top: var(--unit);
  width: 100%;
  text-align: center;
}

.Auth-password {
  width: 100% !important;
  max-width: 312px;
}

.Auth-password .TextInput-input,
.Auth-password .TextInput-input::placeholder {
  color: var(--c-white) !important;
}

.Auth-password .TextInput-submitIcon svg {
  fill: var(--c-white) !important;
}

.Auth-footer {
  position: relative;
  z-index: 100;
  top: -7px;
  margin-top: 64px;
  text-align: center;
}

.Auth-backdrop {
  position: absolute;
  z-index: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: var(--c-black);
}

.Auth .TextInput-input,
.Auth .TextInput-submit {
  background-color: var(--c-grey-dk) !important;
  color: var(--c-grey-lt) !important;
}

.Auth .TextInput-input::placeholder {
  color: var(--c-grey-lt) !important;
}
</style>



// WEBPACK FOOTER //
// Auth.vue?48a17a77